export enum Mask {
  Phone = '+{7} (000) 000-00-00',
}
